import CloseIcon from "@mui/icons-material/Close";
import DownloadIcon from "@mui/icons-material/Download";
import SearchIcon from "@mui/icons-material/Search";
import { Badge, Box, IconButton, Input, Typography } from "@mui/material";
import axios from "axios";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import DataTableItem from "react-data-table-component";
import { useNavigate } from "react-router-dom";
import { baseUrl } from "../utils/constants";
import localizationStrings from "../utils/localizations";
import "./Employees.css";

// const columns = ;

export default function EmployeeListAttendance() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const search = useRef("");
  const [filteredData, setFilteredData] = useState([]);
  const navigate = useNavigate();
  const [, reload] = useState({});

  const getEmployees = useCallback(
    async ({ silent = false, setLoading1 = setLoading } = { silent: false, setLoading1: setLoading }) => {
      if (!silent) setLoading1(true);
      try {
        const data = await axios.get(baseUrl + "getEmployeesOfAttendance");
        if (data.data.status) {
          setData(data.data.result);
          setFilteredData(data.data.result);
        }
        if (!silent) setLoading1(false);
      } catch (e) {
        if (!silent) setLoading1(false);
        console.warn(e);
      }
    },
    [],
  );
  useEffect(() => {
    getEmployees();
    const int = setInterval(() => {
      getEmployees({ silent: true });
    }, 30 * 1000);
    return () => clearInterval(int);
  }, [getEmployees]);

  const handleSearch = () => {
    setFilteredData(data.filter((v) => JSON.stringify(v).toLocaleLowerCase().includes(search.toLocaleLowerCase())));
  };

  return (
    <div style={{ height: "calc(100vh - 56px)", width: "100%", padding: 30 }}>
      <form
        onSubmit={(e) => {
          e.preventDefault();
          handleSearch();
        }}
      >
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            mb: "15px",
          }}
        >
          <Box sx={{ display: "flex", flexDirection: "row", alignItems: "center" }}></Box>
          <Input
            style={{ backgroundColor: "#fff" }}
            placeholder={localizationStrings.Search}
            color="primary"
            value={search.current}
            onChange={(e) => {
              search.current = e.nativeEvent.target.value;
              reload({});
            }}
            endAdornment={
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  alignItems: "center",
                }}
              >
                <IconButton
                  onClick={() => {
                    search.current = "";
                    handleSearch(true);
                  }}
                >
                  <CloseIcon />
                </IconButton>
                <IconButton type="submit" onClick={() => handleSearch()}>
                  <SearchIcon />
                </IconButton>
              </Box>
            }
          />
        </Box>
      </form>
      {loading ? (
        <div
          style={{
            alignItems: "center",
            justifyContent: "center",
            display: "flex",
          }}
        >
          <div className="loader"></div>
        </div>
      ) : (
        <DataTableItem
          data={filteredData}
          columns={[
            {
              selector: (row) => row.Employee_No,
              name: <div>{localizationStrings.EmployeeNo}</div>,
              sortable: true,
              grow: 0.75,
              wrap: true,
              id: "Employee_No",
            },
            {
              selector: (row) => decodeURIComponent(row.Full_Name),
              name: <div>{localizationStrings.Name}</div>,
              sortable: true,
              grow: 2,
              wrap: true,
              id: "Full_Name",
            },
            {
              selector: (row) => row.Mobile_No,
              name: <div>{localizationStrings.MobileNo}.</div>,
              sortable: true,
              grow: 1.5,
              wrap: true,
              id: "Mobile_No",
            },

            {
              selector: (row) => (
                <div>
                  <IconButton
                    type="submit"
                    onClick={() =>
                      navigate("/dashboard-home/employees/attendance/" + row.Employee_No + "/" + row.Full_Name)
                    }
                  >
                    <img src={require("./../assets/images/attendance-1.png")} className="icon-img" />
                  </IconButton>
                </div>
              ),
              name: <div>{localizationStrings.Attendance}</div>,
              sortable: false,
              grow: 3,
              wrap: true,
            },
          ]}
          highlightOnHover
          fixedHeader
          pagination
          responsive
          paginationPerPage={30}
          paginationComponent={({ rowsPerPage, rowCount, currentPage, onChangePage, onChangeRowsPerPage }) => (
            <Box
              sx={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "flex-end",
                minHeight: 56,
              }}
              dir="ltr"
            >
              <Typography
                sx={{
                  margin: "0 24px",
                  color: "rgba(0, 0, 0, 0.54)",
                  fontSize: "13px",
                }}
              >
                {(currentPage - 1) * rowsPerPage + 1}-
                {currentPage * rowsPerPage > rowCount ? rowCount : currentPage * rowsPerPage} of {rowCount}
              </Typography>
              <div style={{ display: "flex", alignItems: "center" }}>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"></path>
                    <path fill="none" d="M24 24H0V0h24v24z"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === 1}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === 1 ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage - 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(currentPage + 1)}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"></path>
                    <path d="M0 0h24v24H0z" fill="none"></path>
                  </svg>
                </button>
                <button
                  className="changeButton"
                  type="button"
                  disabled={currentPage === Math.ceil(rowCount / rowsPerPage)}
                  style={{
                    fill: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                    color: `rgba(0,0,0,${currentPage === Math.ceil(rowCount / rowsPerPage) ? "0.18" : "0.54"})`,
                  }}
                  onClick={() => onChangePage(Math.ceil(rowCount / rowsPerPage))}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                    aria-hidden="true"
                    role="presentation"
                  >
                    <path d="M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"></path>
                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                  </svg>
                </button>
              </div>
            </Box>
          )}
          style={{ height: "calc(100vh - 56px)" }}
          customStyles={{
            headCells: { style: { backgroundColor: "#E8DABC", color: "#000" } },
            responsiveWrapper: {
              style: {
                height: "calc(100vh - 194px)",
              },
            },
          }}
        />
      )}
    </div>
  );
}
